import cn from './list.module.css';

const ListHeader = () => (
  <>
    <div className={cn.volumeRiskTransactionsListHeader}>
      <div className={cn.volumeRiskTransactionsListHeaderBlock}>
        <div className={cn.volumeRiskTransactionsListHeaderText} />
      </div>
      <div className={cn.volumeRiskTransactionsListHeaderIndividual}>
        <div className={cn.volumeRiskTransactionsListHeaderText}>
          Individual customer
        </div>
      </div>
      <div className={cn.volumeRiskTransactionsListHeaderCorporate}>
        <div className={cn.volumeRiskTransactionsListHeaderText}>
          Corporate customer
        </div>
      </div>
    </div>
    <div className={cn.volumeRiskTransactionsListHeaderTitles}>
      <div className={cn.volumeRiskTransactionsListHeaderTitleBlock}>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>
          Risk category
        </div>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>Score</div>
      </div>
      <div className={cn.volumeRiskTransactionsListHeaderTitleBlock}>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>
          Single transaction
        </div>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>
          Multi transaction
        </div>
      </div>
      <div className={cn.volumeRiskTransactionsListHeaderTitleBlock}>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>
          Single transaction
        </div>
        <div className={cn.volumeRiskTransactionsListHeaderTitle}>
          Multi transaction
        </div>
      </div>
    </div>
  </>
);

export default ListHeader;
